module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/caste/caste-grid/caste-grid.component.css
// module id = ./src/app/master/caste/caste-grid/caste-grid.component.css
// module chunks = main